/* The administration workspace — EXP-22. Eight sections, and most of them are **statements**
   rather than controls, so this reads as a document with a status against each heading rather
   than a form full of disabled inputs. A disabled control implies it will be enabled; a sentence
   saying a thing is not built says what is true. */

.sections {
  width: 100%;
  min-width: 0;
  overflow-wrap: anywhere;
  border-collapse: collapse;
}

.section {
  border-top: 1px solid var(--line);
}

/* The heading row of a section group: the row itself adds nothing; its cell carries the spacing. */
.groupRow {
  background: transparent;
}

.groupHead {
  padding: 14px 0 0;
  text-align: start;
}

.noteCell {
  padding: 4px 0 8px;
}

.head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.title {
  margin: 0;
  font-size: var(--t-dense);
  font-weight: 650;
  color: var(--ink);
}

/* The state is the point of the screen, so it is a chip a reader cannot skim past. **Four**
   of them, because "not built" and "nothing here yet" are different facts and one neutral
   "unavailable" would report a gap and a state alike. */
.state {
  display: inline-block;
  padding: 1px 6px;
  border: 1px solid var(--line-2);
  border-radius: 999px;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--muted);
}

.state::first-letter {
  text-transform: uppercase;
}

.settled {
  border-color: var(--accent-line);
  background: var(--accent-w);
  color: var(--accent);
}

.notBuilt {
  border-color: var(--warn-line);
  background: var(--warn-w);
  color: var(--warn);
}

.summary {
  margin: 6px 0 0;
  font-size: var(--t-min);
  color: var(--muted);
  line-height: 1.5;
}

.blocked {
  margin: 10px 0 0;
  padding: 8px 10px;
  border-left: 2px solid var(--warn-line);
  background: var(--warn-w);
  font-size: var(--t-min);
  color: var(--ink-2);
  line-height: 1.55;
}

.item > th,
.item > td {
  padding: 6px 10px 6px 0;
  vertical-align: baseline;
  text-align: start;
  border-top: 1px solid var(--line);
}

.label {
  width: 12rem;
  font-size: var(--t-min);
  font-weight: 400;
  color: var(--muted);
}

.value {
  /* A value is a word or a name: a long note beside it must not squeeze it into a column of one word
     per line ("Empty / co / Foods / Inc."). */
  min-width: 12rem;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--ink);
}

/* "Not available" is set apart from a real value so that a reader scanning the right-hand
   column can see at a glance which rows are facts about the product and which are settings. */
.unavailable {
  font-weight: 500;
  font-style: italic;
  color: var(--muted);
}

.detail {
  font-size: var(--t-min);
  color: var(--muted);
  line-height: 1.55;
}

.link {
  font-size: var(--t-min);
  color: var(--accent);
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}
